<template>
  <div class="study-logs">
    <div class="study-panel ta--bg-primary" v-if="$route.query.status == 'show'">
      <p>审核学时</p>
      <p><strong>{{$route.query.dur || 0}}</strong>分钟</p>
    </div>
    <template v-if="listData.length > 0">
      <div class="panel-item" v-for="item in listData">
        <div class="info-group">
          <p class="info">签到时间：{{item.signInTime|fmtTime}}</p>
          <p class="info">签退时间：{{item.signOutTime|fmtTime}}</p>
          <p class="info" :class="item.status == 1 ? 'primary ta--text-primary' : ''">
            {{(item.status == 1 && $route.query.status == 'show') ? '审核学时' : '培训学时'}}：{{parseInt(item.dur / 60)}}分钟
          </p>
          <p class="info feedback ta--text-error" v-if="item.feedback && item.status == 3">审核说明：{{item.feedback}}</p>
        </div>
        <template v-if="$route.query.status == 'show'">
          <div class="resign ta--bg-primary" v-if="item.canResign" @click="resign(item)">补签</div>
          <i class="icon mdi mdi-check-circle success ta--text-success" v-else-if="item.status == 1"></i>
          <i class="icon mdi mdi-close-circle error" v-else-if="item.status == 3"></i>
          <i class="icon mdi mdi-clock-outline" v-else></i>
        </template>
        <template v-else>
          <div class="resign ta--bg-primary" v-if="item.canResign" @click="resign(item)">补签</div>
          <i class="icon mdi mdi-close-circle error" v-else-if="item.status == 3"></i>
        </template>
      </div>
    </template>
    <div class="empty-list" v-else>
      <i class="icon mdi mdi-file-document"></i>
      <span>没有学习记录</span>
    </div>
  </div>
</template>

<script>
  import formatTime from "@/utils/formatTime.js";
	import { mapState } from 'vuex';
  export default {
    name: "StudyLogs",
    data() {
      return {
        listData: [],
      }
    },
    beforeMount() {
			sessionStorage.removeItem('logId')
			this.$store.commit('changeNav', '学时查询')
      this.init()
    },
    methods: {
    	init() {
				this.$axios.get(`/m/home/my/clazz/log/${this.$route.query.cid}`)
					.then(resp => {
						let d = resp.data
						switch (d.status) {
							case 'ok':
								this.listData = d.message || []
								break
							case 'err':
								this.$toast(d.message || '未知错误')
								break
						}
					})
			},
			resign(item) {
				if(item.canResign) {
					sessionStorage.setItem('logId', item.id)
					this.$store.commit('needFaceRecognition', 3)
        } else {
					this.$toast('当前不可签退')
        }

      }
    },
    filters: {
      fmtTime(data) {
        return data ? formatTime(data, 'fullDateTime') : "";
      }
    },
		computed: {
			...mapState([
				'updateResignTs',
			])
		},
		watch: {
			updateResignTs() {
				this.init()
			}
    }
  }
</script>

<style lang="scss" scoped>
  .study-logs {
    .study-panel {
      margin-bottom: 10px;
      background: $primary;
      background: var(--primary);
      padding: 20px;
      color: #fff;
      p {
        font-size: 12px;
        margin-bottom: 10px;
        strong {
          font-size: 36px;
          margin-right: 6px;
        }
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
    .panel-item {
      padding: 15px;
      background: #fff;
      margin-bottom: 10px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .info-group {
        text-align: left;
        .info {
          font-size: 12px;
          margin-bottom: 6px;
          &.primary {
            color: $primary;
            color: var(--primary);
          }
          &.feedback {
            color: $error;
            color: var(--error);
          }
          &:last-child {
            margin-bottom: 0;
          }
        }
      }
      .icon {
        font-size: 30px;
        flex-shrink: 0;
        color: #9E9E9E;
        &.success {
          color: $success;
          color: var(--success);
        }
        &.error {
          color: $error;
        }
      }
      .resign {
        font-size: 15px;
        padding: 5px 12px;
        color: #fff;
        background: $primary;
        background: var(--primary);
        border-radius: 4px;
      }
    }
    .empty-list {
      padding: 60px 15px;
      display: flex;
      flex-direction: column;
      align-items: center;
      color: #666;
      font-size: 12px;
      background: #fff;
      .icon {
        font-size: 60px;
        line-height: 1;
        color: #C7C7C7;
        height: 60px;
        margin-bottom: 10px;
      }
    }
  }
</style>a